import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonDirective } from 'src/app/shared/directives/button.directive';
import { ConversionFormat } from 'src/app/tools/convert/templates/conversion-template/conversion-template.component';

@Component({
  selector: 'app-conversion-format-select-menu-item',
  standalone: true,
  imports: [CommonModule, ButtonDirective, RouterLink],
  templateUrl: './conversion-format-select-menu-item.component.html',
  styleUrls: ['./conversion-format-select-menu-item.component.scss'],
})
export class ConversionFormatSelectMenuItemComponent {
  @Input() format: ConversionFormat;
  @Input() mode: 'from' | 'to';
  @Input() linkMode: boolean;
  @Input() fromFormat: ConversionFormat;
  @Input() toFormat: ConversionFormat;
  @Input() active: boolean;

  @Output() formatSelected = new EventEmitter<ConversionFormat>();
}
